import "./scss/index.scss";

import {
  faAngleDown,
  faAngleLeft,
  faAngleUp,
  faDesktop,
  faSearch,
  faTh,
  faThList,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faInstagram,
  faSnapchat,
  faSoundcloud,
  faSpotify,
  faAmazon,
  faTwitter,
  faYoutube,
  faTiktok,
  faApple,
} from "@fortawesome/free-brands-svg-icons";

import App from "./App.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Vue from "vue";
import VueAnalytics from "vue-analytics";
import { VueSpinners } from "@saeris/vue-spinners";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faTh);
library.add(faThList);
library.add(faFacebook);
library.add(faInstagram);
library.add(faTwitter);
library.add(faYoutube);
library.add(faTiktok);
library.add(faSpotify);
library.add(faAmazon);
library.add(faApple);
library.add(faDesktop);
library.add(faSnapchat);
library.add(faAngleDown);
library.add(faAngleUp);
library.add(faSearch);
library.add(faSoundcloud);
library.add(faAngleLeft);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(VueSpinners);
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GA,
  /*debug: {
    enabled: true,
    trace: true,
    sendHitTask: true
  },*/
});

Vue.config.productionTip = false;
const querySelector = "#ww";
const mountEl = document.querySelector(querySelector);

new Vue({
  render: (h) => {
    const context = {
      props: {
        dataPath: mountEl.attributes["data-path"].value,
        appId: mountEl.attributes["data-path"].value.split("/")[0],
      },
    };
    return h(App, context);
  },
}).$mount(querySelector);
